module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    ref: "orderAddress",
    staticClass: "orderAddress"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticStyle: {
      "width": "90%",
      "margin": "auto"
    },
    attrs: {
      "label-position": "top",
      "size": "mini",
      "label-width": "80px",
      "show-message": false,
      "hide-required-asterisk": "",
      "model": _vm.orderAddress,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('name') + '：',
      "prop": "CustomerName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderAddress.CustomerName),
      callback: function($$v) {
        _vm.$set(_vm.orderAddress, "CustomerName", $$v)
      },
      expression: "orderAddress.CustomerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('phone') + '：',
      "prop": "LinkmanPhone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderAddress.LinkmanPhone),
      callback: function($$v) {
        _vm.$set(_vm.orderAddress, "LinkmanPhone", $$v)
      },
      expression: "orderAddress.LinkmanPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('address') + '：',
      "prop": "Street"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderAddress.Street),
      callback: function($$v) {
        _vm.$set(_vm.orderAddress, "Street", $$v)
      },
      expression: "orderAddress.Street"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('zip') + '：',
      "prop": "Zip"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderAddress.Zip),
      callback: function($$v) {
        _vm.$set(_vm.orderAddress, "Zip", $$v)
      },
      expression: "orderAddress.Zip"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('city') + '：',
      "prop": "City"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderAddress.City),
      callback: function($$v) {
        _vm.$set(_vm.orderAddress, "City", $$v)
      },
      expression: "orderAddress.City"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('province') + '：',
      "prop": "Province"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderAddress.Province),
      callback: function($$v) {
        _vm.$set(_vm.orderAddress, "Province", $$v)
      },
      expression: "orderAddress.Province"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83a384fe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/myaddress/myaddressedit.vue
// module id = 475
// module chunks = 1